import directives from './module';
import {Wrapped} from '../services/AdSvc';

class AdBanner implements ng.IComponentController {
    readonly ad: Wrapped;
}

directives.component('adBanner', {
    bindings: {
        ad: '<'
    },
    controller: AdBanner,
    templateUrl: require('video-banner.html')
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/AdBanner.ts